import { render } from "./link.vue?vue&type=template&id=010688f5"
const script = {}
script.render = render

export default script